import React from 'react'
import FeatureNav from './FeatureNav';
import FooterSection from './FooterSection';
import HeaderComponent from './HeaderComponent';
import BreadCrumbs from './BreadCrumbs';

const NotFound = () => {
  return (
    <main>
      <HeaderComponent/>
      <FeatureNav />
      <BreadCrumbs/>
      <section className="mt-20">
        <div className="text-center mb-5">
            <h1 className="display-5 fw-bold mb-3">404</h1>
        </div>
        <div className="text-center mb-5">
          <p className="lead text-muted">
          404 - The page you're looking for doesn't exist
          </p>
        </div>
      </section>
      <FooterSection />
    </main>
  )
}

export default NotFound;